import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { sortSelect, DocumentFilter, filterHeaderBar, formatDocumentSize, getDocumentUploader } from "../../Documents/DocumentHelpers.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Grid, IconButton, Link, Fade, Switch, FormControlLabel, Paper } from "@mui/material";
import { join } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty as empty_1, ofArray } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { toDateAndTimeStr } from "../../Locale.js";
import { Message, dispatchCtx, documentsCtx } from "../../Documents/DocumentContext.js";
import { API_Document_MultiDownload } from "../../Shared/Urls.js";
import { map } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/Guid.js";
import { empty, toList, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_Searchbar_25F45B5E } from "../Searchbar.js";
import { debounce as debounce_1 } from "../../Utils.js";
import Download from "@mui/icons-material/Download";
import { CategorySelection } from "./CategorySelect.js";
import { defaultArg, unwrap } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { HookImports_useMediaQuery } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Hooks.fs.js";

export function Documents_MetaRow_Z45A274A0(documents_MetaRow_Z45A274A0InputProps) {
    const value = documents_MetaRow_Z45A274A0InputProps.value;
    const label = documents_MetaRow_Z45A274A0InputProps.label;
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
        },
        children: reactApi.Children.toArray([label, value]),
    });
}

export function Documents_MetaCard_6F67B1E7(document$) {
    let elements, elems, elems_1;
    const ctx = reactApi.useContext(ctx_1);
    const uploader = getDocumentUploader(document$.Uploader);
    return MuiHelpers_createElement(Paper, [["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        rowGap: 5 + "px",
        padding: 10 + "px",
    }], (elements = [createElement(Documents_MetaRow_Z45A274A0, {
        label: createElement("b", {
            children: ["Filnavn"],
        }),
        value: createElement("span", {
            className: join(" ", ["text-overflow"]),
            style: {
                display: "inline-block",
                maxWidth: 40 + "ch",
            },
            title: document$.Filename,
            children: document$.Filename,
        }),
    }), createElement(Documents_MetaRow_Z45A274A0, {
        label: createElement("b", {
            children: ["Versjon"],
        }),
        value: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems = [createElement("span", {
            style: {
                textAlign: "right",
            },
            children: `${document$.Version}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
    }), createElement(Documents_MetaRow_Z45A274A0, {
        label: createElement("b", {
            children: ["Filstørrelse"],
        }),
        value: createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
        }], (elems_1 = [createElement("span", {
            children: `${formatDocumentSize(document$.ContentSizeBytes)}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
    }), createElement(Documents_MetaRow_Z45A274A0, {
        label: createElement("b", {
            children: ["Opplaster"],
        }),
        value: createElement("span", {
            children: [uploader],
        }),
    }), createElement(Documents_MetaRow_Z45A274A0, {
        label: createElement("b", {
            children: ["Lastet opp"],
        }),
        value: createElement("span", {
            children: [toDateAndTimeStr(ctx.DateFnsLocale, document$.Uploaded)],
        }),
    })], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Container with filter header
 */
export function Documents_ContainerWithFilter_Z2776732D(documents_ContainerWithFilter_Z2776732DInputProps) {
    let elems_1;
    const machineId = documents_ContainerWithFilter_Z2776732DInputProps.machineId;
    const children = documents_ContainerWithFilter_Z2776732DInputProps.children;
    const selectedDocs = documents_ContainerWithFilter_Z2776732DInputProps.selectedDocs;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(undefined);
    const timer = reactApi.useRef(0);
    let patternInput_1;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput_1 = [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin];
    }
    else {
        patternInput_1 = [false, false];
    }
    const isAdmin = patternInput_1[1];
    const selectedFilesUrl = API_Document_MultiDownload(map(parse, selectedDocs));
    return createElement("div", createObj(ofArray([["className", join(" ", ["document-filter-header"])], ["style", {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        width: 100 + "%",
        borderRadius: 15 + "px",
        gap: 30 + "px",
    }], (elems_1 = [filterHeaderBar(toArray(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            flexGrow: 1,
            flexShrink: 0,
            columnGap: 15 + "px",
            flexWrap: "wrap",
        }], (elems = toList(delay(() => append(singleton(createElement("div", {
            style: {
                flexBasis: 320 + "px",
            },
            children: createElement(Components_Searchbar_25F45B5E, {
                placeholder: ctx.Locale.t("Search"),
                onChange: (ev) => {
                    const str = ev.target.value;
                    debounce_1(500, timer, () => {
                        let bind$0040_1;
                        dispatch(new Message(13, [(bind$0040_1 = model.Filter, new DocumentFilter(bind$0040_1.Sort, str, bind$0040_1.HideNonSynced, bind$0040_1.ShowDeleted))]));
                    });
                },
            }),
        })), delay(() => ((patternInput_1[0] ? true : isAdmin) ? append(singleton(MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Document.EditingMode")], ["control", MuiHelpers_createElement(Switch, [["onChange", (e) => {
            const newEditing = e.target.checked;
            console.debug("Start editing documents from machine view!");
            dispatch(new Message(12, [newEditing]));
        }], ["checked", model.Editing]])]])), delay(() => ((isAdmin && model.Editing) ? singleton(MuiHelpers_createElement(Fade, [["in", model.Editing], ["children", MuiHelpers_createElement(FormControlLabel, [["classes.label", "text-overflow"], ["label", "Vis slettede dokumenter"], ["control", MuiHelpers_createElement(Switch, [["onChange", (e_1) => {
            let bind$0040_2;
            dispatch(new Message(13, [(bind$0040_2 = model.Filter, new DocumentFilter(bind$0040_2.Sort, bind$0040_2.SearchTerm, bind$0040_2.HideNonSynced, e_1.target.checked))]));
        }], ["checked", model.Filter.ShowDeleted]])]])]])) : empty()))) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let props_8;
            return append(singleton(MuiHelpers_createElement(Link, [["href", selectedFilesUrl], ["children", MuiHelpers_createElement(IconButton, [["disabled", selectedDocs.length === 0], ["children", (props_8 = {}, react.createElement(Download, props_8))]])]])), delay(() => {
                let matchValue_1, id;
                return append((matchValue_1 = machineId, (matchValue_1 != null) ? ((id = (matchValue_1 | 0), singleton(createElement(CategorySelection, {
                    machineId: id,
                    categoryId: unwrap(patternInput[0]),
                    onChange: patternInput[1],
                })))) : (empty())), delay(() => singleton(sortSelect(ctx.Language, ctx.Locale, (sort) => {
                    let bind$0040;
                    dispatch(new Message(13, [(bind$0040 = model.Filter, new DocumentFilter(sort, bind$0040.SearchTerm, bind$0040.HideNonSynced, bind$0040.ShowDeleted))]));
                }, model.Filter.Sort))));
            }));
        }));
    }))), children], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Documents_Container_Z39E676A4(documents_Container_Z39E676A4InputProps) {
    const children = documents_Container_Z39E676A4InputProps.children;
    return createElement("div", {
        className: join(" ", ["documents-container"]),
        style: {
            display: "flex",
            width: 100 + "%",
        },
        children: reactApi.Children.toArray([children]),
    });
}

export function Documents_GridItem_Z6D87F33A(documents_GridItem_Z6D87F33AInputProps) {
    const classes = documents_GridItem_Z6D87F33AInputProps.classes;
    const children = documents_GridItem_Z6D87F33AInputProps.children;
    return MuiHelpers_createElement(Grid, [["className", join(" ", defaultArg(classes, empty_1()))], ["xs", 12], ["lg", 12], ["xl", 5], ["item", true], ["children", reactApi.Children.toArray([children])]]);
}

export function Documents_Grid_Z39E676A4(documents_Grid_Z39E676A4InputProps) {
    const children = documents_Grid_Z39E676A4InputProps.children;
    const isXL = HookImports_useMediaQuery("(min-width: 1536px)");
    return MuiHelpers_createElement(Grid, [["style", createObj(toList(delay(() => append(singleton(["height", 100 + "%"]), delay(() => append(singleton(["rowGap", 40 + "px"]), delay(() => append(singleton(["alignItems", "flex-start"]), delay(() => (isXL ? singleton(["justifyContent", "space-evenly"]) : empty()))))))))))], ["spacing", 3], ["container", true], ["direction", "row"], ["wrap", "wrap"], ["children", reactApi.Children.toArray([children])]]);
}

